import React from 'react';
import { VaBreadcrumbs } from '@department-of-veterans-affairs/component-library/dist/react-bindings';

import { DISABILITY_526_V2_ROOT_URL } from '../../shared/constants/entryConstants';

export const getBreadcrumbList = (title, href = DISABILITY_526_V2_ROOT_URL) => [
  { href: '/', label: 'Home' },
  { href: '/disability', label: 'Disability Benefits' },
  { href, label: title },
];

// Renders Home > Disability Benefits > form title above the given content.
const wrapWithBreadcrumb = (title, component, href) => (
  <>
    <div className="row vads-u-padding-x--1p5">
      <VaBreadcrumbs uswds breadcrumbList={getBreadcrumbList(title, href)} />
    </div>
    {component}
  </>
);

export default wrapWithBreadcrumb;
